import { KnmResultDecisionAgreementStatusEnum } from 'APIPackage/KnmModule/enums/KnmResultDecisionAgreementStatusEnum';

export const mapResultDecisionAgreementStatusToColor: Record<
  KnmResultDecisionAgreementStatusEnum,
  'green' | 'red' | 'yellow' | 'blue'
> = {
  [KnmResultDecisionAgreementStatusEnum.AGREEMENT_DRAFT]: 'blue',
  [KnmResultDecisionAgreementStatusEnum.AGREEMENT_CANCELED]: 'red',
  [KnmResultDecisionAgreementStatusEnum.AGREEMENT_READY_TO_APPROVE]: 'blue',
  [KnmResultDecisionAgreementStatusEnum.AGREEMENT_ON_APPROVAL]: 'yellow',
  [KnmResultDecisionAgreementStatusEnum.AGREEMENT_DENIED]: 'red',
  [KnmResultDecisionAgreementStatusEnum.AGREEMENT_APPROVED]: 'green',
  [KnmResultDecisionAgreementStatusEnum.AGREEMENT_NOT_COMPLETED_WAITING_TERMINATION]: 'red',
  [KnmResultDecisionAgreementStatusEnum.AGREEMENT_TERMINATED]: 'red',
  [KnmResultDecisionAgreementStatusEnum.AGREEMENT_COMPLETED]: 'green',
  [KnmResultDecisionAgreementStatusEnum.AGREEMENT_NOT_COMPLETED]: 'red',
};
